import type { PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Tooltip } from '~/components';

export const ArtistCrossoverTooltip = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation('roster');

  return (
    <Tooltip
      content={
        <div className="leading-4">
          <Trans
            {...{
              t,
              i18nKey: 'crossover.tooltip',
              components: { br: <br /> },
            }}
          />
        </div>
      }
      size="sm"
      align="start"
      sideOffset={4}
      triggerAsChild
    >
      <button className="flex">{children}</button>
    </Tooltip>
  );
};

ArtistCrossoverTooltip.displayName = 'ArtistCrossoverTooltip';
